import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import {
    FormWrapperItem,
    StatusComponent
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import TextArea from "../../../../common/component/TextArea";
import Input, { InputGroup } from "../../../../common/component/Input";
import { Skeleton, Descriptions, Icon } from 'antd';
import Order, { OrderInvoice } from '../../../../../../models/Order';

import './InvoiceInfo.less';
import { getLocaleFullName } from '../../../../../../utils/commonUtils';
import Ripple from '../../../../common/component/Ripple';

import { cloneDeep, isEqual } from 'lodash';
import Span from '../../../../common/component/Span';
export default class InvoiceInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            invoiceEditing: new OrderInvoice(),
            validation: {},
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.invoice && !isEqual(this.props.invoice, prevProps.invoice)) {
            this.setState({ editing: false, invoiceEditing: cloneDeep(this.props.invoice) });
        }
    }

    render() {
        const { t, invoice, loading, permisions } = this.props;
        const { editing, invoiceEditing } = this.state;
        return (
            <Wrapper className="order-invoice-section col-md-12 mb-3">
                <h3 className={`ml-0`}>{t('item.order.invoiceInfo')}</h3>
                <Wrapper className={`row mt-2`}>
                    {!loading ?
                        <Descriptions bordered className="white-bg w100-percent" column={2}>
                            <Descriptions.Item label={this.renderRequiredLabel(t('item.order.fullName'))}>{this.renderEditingInput('fullName')}</Descriptions.Item>
                            <Descriptions.Item label={this.renderRequiredLabel(t('item.order.companyName'))}>{this.renderEditingInput('companyName')}</Descriptions.Item>
                            <Descriptions.Item label={this.renderRequiredLabel(t('item.order.address'))}>{this.renderEditingInput('address')}</Descriptions.Item>
                            <Descriptions.Item label={this.renderRequiredLabel(t('item.order.taxCode'))}>{this.renderEditingInput('taxCode')}</Descriptions.Item>
                        </Descriptions>
                        : <Skeleton active paragraph={{ row: 7 }} />
                    }
                </Wrapper>
                {permisions && permisions.allowUpdate &&
                    <Wrapper className={`editing-buttons ${editing ? 'editing' : ''}`}>
                        <Ripple waitForEffect={true} className={`btn-edit p-1 mr-1`} onClick={!editing ? this.onClickEdit : this.onClickCancel}><Icon type={editing ? 'close' : 'edit'} /> {editing ? t(`action.cancel`) : t(`action.edit`)}</Ripple>
                        {editing && <Ripple waitForEffect={true} className={`btn-save p-1`} disabled={loading || isEqual(invoiceEditing, invoice)} onClick={this.onClickSave}><Icon type='save' /> {t(`action.save`)}</Ripple>}
                    </Wrapper>
                }
            </Wrapper>
        );
    }

    renderRequiredLabel(label) {
        const { editing } = this.state;
        return editing ? (
            <Fragment>{label}<Span style={{ color: 'red' }}>{'*'}</Span></Fragment>
        ) : label;
    }

    renderErrorMessage(error) {
        return error && error.messageError && <Wrapper className="error-message"><Span>{error.messageError}</Span></Wrapper>
    }

    renderEditingInput(fieldName) {
        const { t, invoice } = this.props;
        const { editing, invoiceEditing, validation } = this.state;
        return (editing
            ? <Wrapper className={!!(validation[fieldName]) ? 'validate-failed' : ''}>
                <Input value={invoiceEditing[fieldName]}
                    placeholder={t(`item.order.${fieldName}`)}
                    onChange={e => this.onChangeEditing(fieldName, e.target.value)} />
                {this.renderErrorMessage(validation[fieldName])}
            </Wrapper>
            : (invoice[fieldName])
        )
    }

    onClickEdit = (e) => {
        const invoiceEditing = cloneDeep(this.props.invoice);
        this.setState({ editing: !this.state.editing, invoiceEditing, validation: {} })
    }

    onClickCancel = (e) => {
        const invoiceEditing = cloneDeep(this.props.invoice);
        this.setState({ editing: false, invoiceEditing, validation: {} })
    }

    onClickSave = (e) => {
        // this.setState({ editing: !this.state.editing });
        if (this.validate(this.state.invoiceEditing)) {
            this.props.onUpdateInvoice(this.state.invoiceEditing);
        }
    }

    onChangeEditing = (fieldName, value) => {
        const invoiceEditing = this.state.invoiceEditing;
        invoiceEditing[fieldName] = value;
        this.setState({ invoiceEditing })
    }

    validate(invoice) {
        const { t } = this.props;
        let validate = {
            required: {
                fullName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.fullName`)),
                companyName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.companyName`)),
                address: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.address`)),
                taxCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.order.taxCode`)),
            }
        };
        let valueValidate = {};
        const result = Func.multipleValidate(invoice, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}

InvoiceInfo.defaultProps = {
    invoice: new OrderInvoice(),
    onUpdateInvoice: invoice => { },
    loading: false,
    permisions: {},
};